// extracted by mini-css-extract-plugin
export var email = "styles-module--email--1702d";
export var subtitle = "styles-module--subtitle--c897a";
export var title = "styles-module--title--e1410";
export var wrapper = "styles-module--wrapper--6ab9e";